/**
 * 拓扑插件-事件名称常量定义
 */

/**
 * 拓扑插件-定义拓扑通用事件名称
 * @type eventNameObject 事件名称对象
 */
export const generalEvent = {
  // 单击鼠标左键或者按下回车键时触发
  click: 'click',

  // 双击鼠标左键时触发，同时会触发两次 click
  dblClick: 'dblclick',

  // 鼠标移入元素范围内触发，该事件不冒泡，即鼠标移到其后代元素上时不会触发
  mouseEnter: 'mouseenter',

  // 鼠标在元素内部移到时不断触发，不能通过键盘触发
  mouseMove: 'mousemove',

  // 鼠标移出目标元素后触发
  mouseOut: 'mouseout',

  // 鼠标移入目标元素上方，鼠标移到其后代元素上时会触发
  mouseOver: 'mouseover',

  // 鼠标移出元素范围时触发，该事件不冒泡，即鼠标移到其后代元素时不会触发
  mouseLeave: 'mouseleave',

  // 鼠标按钮被按下（左键或者右键）时触发，不能通过键盘触发
  mouseDown: 'mousedown',

  // 鼠标按钮被释放弹起时触发，不能通过键盘触发
  mouseUp: 'mouseup',

  // 用户右击鼠标时触发并打开上下文菜单，见 Demo
  contextMenu: 'contextmenu',

  // 当拖拽元素开始被拖拽的时候触发的事件，此事件作用在被拖曳元素上
  dragStart: 'dragstart',

  // 当拖拽元素在拖动过程中时触发的事件，此事件作用于被拖拽元素上
  drag: 'drag',

  // 当拖拽完成后触发的事件，此事件作用在被拖曳元素上
  dragEnd: 'dragend',

  // 当拖曳元素进入目标元素的时候触发的事件，此事件作用在目标元素上
  dragEnter: 'dragenter',

  // 当拖曳元素离开目标元素的时候触发的事件，此事件作用在目标元素上
  dragLeave: 'dragleave',

  // 被拖拽的元素在目标元素上同时鼠标放开触发的事件，此事件作用在目标元素上
  drop: 'drop',

  // 按下键盘键触发该事件
  keydown: 'keydown',

  // 释放键盘键触发该事件
  keyup: 'keyup',

  // 鼠标滚轮滚动时触发该事件
  wheel: 'wheel',

  // 当手指触摸屏幕时候触发，即使已经有一个手指放在屏幕上也会触发
  touchStart: 'touchstart',

  // 当手指在屏幕上滑动的时候连续地触发。在这个事件发生期间，调用 preventDefault() 事件可以阻止滚动。
  touchMove: 'touchmove',

  // 当手指从屏幕上离开的时候触发
  touchEnd: 'touchend'
};


/**
 * 拓扑插件-定义拓扑节点事件名称
 * @type eventNameObject 事件名称对象
 */
export const nodeEvent = {
  
  // 鼠标左键单击节点时触发
  click: 'node:click',
  
  // 鼠标双击左键节点时触发，同时会触发两次 node:click
  dblClick: 'node:dblclick',
  
  // 鼠标移入节点时触发
  mouseEnter: 'node:mouseenter',
  
  // 鼠标在节点内部移到时不断触发，不能通过键盘触发
  mouseMove: 'node:mousemove',
  
  // 鼠标移出节点后触发
  mouseOut: 'node:mouseout',
  
  // 鼠标移入节点上方时触发
  mouseOver: 'node:mouseover',
  
  // 鼠标移出节点时触发
  mouseLeave: 'node:mouseleave',
  
  // 鼠标按钮在节点上按下（左键或者右键）时触发，不能通过键盘触发
  mouseDown: 'node:mousedown',
  
  // 节点上按下的鼠标按钮被释放弹起时触发，不能通过键盘触发
  mouseUp: 'node:mouseup',
  
  // 当节点开始被拖拽的时候触发的事件，此事件作用在被拖曳节点上
  dragStart: 'node:dragstart',
  
  // 当节点在拖动过程中时触发的事件，此事件作用于被拖拽节点上
  drag: 'node:drag',
  
  // 当拖拽完成后触发的事件，此事件作用在被拖曳节点上
  dragEnd: 'node:dragend',
  
  // 当拖曳节点进入目标元素的时候触发的事件，此事件作用在目标元素上
  dragEnter: 'node:dragenter',
  
  // 当拖曳节点离开目标元素的时候触发的事件，此事件作用在目标元素上
  dragLeave: 'node:dragleave',
  
  // 当拖曳节点在另一目标元素上移动时触发此事件，此事件作用在目标元素上
  dragOver: 'node:dragover',
  
  // 被拖拽的节点在目标元素上同时鼠标放开触发的事件，此事件作用在目标元素上
  drop: 'node:drop',
  
  // 在触控屏上，当节点开始被触碰的时候触发的事件
  touchStart: 'node:touchstart',
  
  // 在触控屏上，当节点开始被触碰过程中触发的事件
  touchMove: 'node:touchmove',
  
  // 在触控屏上，当节点开始被触碰结束的时候触发的事件
  touchEnd: 'node:touchend',
  
  // 用户在节点上右击鼠标时触发并打开右键菜单，见 Demo
  contextMenu: 'node:contextmenu'
};


/**
 * 拓扑插件-定义拓扑边（连线）事件名称
 * @type eventNameObject 事件名称对象
 */
export const edgeEvent = {

  // 鼠标左键单击边时触发
  click: 'edge:click',

  // 鼠标双击左键边时触发，同时会触发两次 edge:click
  dblClick: 'edge:dblclick',

  // 鼠标移入边时触发
  mouseEnter: 'edge:mouseenter',

  // 鼠标在边上移到时不断触发，不能通过键盘触发
  mouseMove: 'edge:mousemove',

  // 鼠标移出边后触发
  mouseOut: 'edge:mouseout',

  // 鼠标移入边上方时触发
  mouseOver: 'edge:mouseover',

  // 鼠标移出边时触发
  mouseLeave: 'edge:mouseleave',

  // 鼠标按钮在边上按下（左键或者右键）时触发，不能通过键盘触发
  mouseDown: 'edge:mousedown',

  // 边上按下的鼠标按钮被释放弹起时触发，不能通过键盘触发
  mouseUp: 'edge:mouseup',

  // 当拖曳元素进入目标边元素的时候触发的事件，此事件作用在目标边元素上
  dragEnter: 'edge:dragenter',

  // 当拖曳元素离开目标边元素的时候触发的事件，此事件作用在目标边元素上
  dragLeave: 'edge:dragleave',

  // 当拖曳元素在另一目标边上移动时触发此事件，此事件作用在目标边元素上
  dragOver: 'edge:dragover',

  // 被拖拽的元素在目标边元素上同时鼠标放开触发的事件，此事件作用在目标边元素上
  drop: 'edge:drop',

  // 用户在边上右击鼠标时触发并打开右键菜单，见 Demo
  contextMenu: 'edge:contextmenu'
};


export const timingEventName = {
  // 调用 graph.render / graph.read 方法之前触发
  beforeRender: 'beforerender',

  // 调用 graph.render / graph.read 方法之后触发
  afterRender: 'afterrender',

  // 调用 graph.add / graph.addItem 方法之前触发
  beforeAddItem: 'beforeadditem',

  // 调用 graph.add / graph.addItem 方法之后触发
  afterAddItem: 'afteradditem',

  // 调用 graph.remove / graph.removeItem 方法之前触发
  beforeRemoveItem: 'beforeremoveitem',

  // 调用 graph.remove / graph.removeItem 方法之后触发
  afterRemoveItem: 'afterremoveitem',

  // 调用 graph.update / graph.updateItem 方法之前触发
  beforeUpdateItem: 'beforeupdateitem',

  // 调用 graph.update / graph.updateItem 方法之后触发
  afterUpdateItem: 'afterupdateitem',

  // 调用 graph.showItem / graph.hideItem 方法之前触发
  beforeItemVisibilityChange: 'beforeitemvisibilitychange',

  // 调用 graph.showItem / graph.hideItem 方法之后触发
  afterItemVisibilityChange: 'afteritemvisibilitychange',

  // 调用 graph.setItemState 方法之前触发
  beforeItemStateChange: 'beforeitemstatechange',

  // 调用 graph.setItemState 方法之后触发
  afterItemStateChange: 'afteritemstatechange',

  // 调用 graph.refreshItem 方法之前触发
  beforeItemRefresh: 'beforeitemrefresh',

  // 调用 graph.refreshItem 方法之后触发
  afterItemRefresh: 'afteritemrefresh',

  // 调用 graph.clearItemStates 方法之前触发
  beforeItemStatesClear: 'beforeitemstatesclear',

  // 调用 graph.clearItemStates 方法之后触发
  afterItemStatesClear: 'afteritemstatesclear',

  // 调用 graph.setMode / graph.addBehaviors / graph.removeBehaviors 方法之前触发
  beforeModeChange: 'beforemodechange',

  // 调用 graph.setMode / graph.addBehaviors / graph.removeBehaviors 方法之后触发
  afterModeChange: 'aftermodechange',

  // 布局前触发。调用 graph.render 时会进行布局，因此 render 时会触发。或用户主动调用图的 graph.layout 时触发。
  beforeLayout: 'beforelayout',

  // 布局完成后触发。调用 graph.render 时会进行布局，因此 render 时布局完成后会触发。或用户主动调用图的 graph.layout 时布局完成后触发。
  afterLayout: 'afterlayout',

  // graph.refreshPositions 被调用前触发
  beforeGraphRefreshPosition: 'beforegraphrefreshposition',

  // graph.refreshPositions 被调用后触发
  afterGraphRefreshPosition: 'aftergraphrefreshposition',

  // graph.refresh 被调用前触发
  beforeGraphRefresh: 'beforegraphrefresh',

  // graph.refresh 被调用后触发
  afterGraphRefresh: 'aftergraphrefresh',

  // 全局动画发生前触发
  beforeAnimate: 'beforeanimate',

  // 全局动画发生后触发
  afterAnimate: 'afteranimate',

  // 使用内置交互 create-edge，创建边之前触发
  beforeCreateEdge: 'beforecreateedge',

  // 使用内置交互 create-edge，创建边之后触发
  afterCreateEdge: 'aftercreateedge',

  // 当一个 combo 被收起或展开之前被触发，参数 action 指明了是收起还是展开
  beforeCollapseExpandCombo: 'beforecollapseexpandcombo',

  // 当一个 combo 被收起或展开之后被触发，参数 action 指明了是收起还是展开
  afterCollapseExpandCombo: 'aftercollapseexpandcombo',

  // 调用 graph.updateItemState 方法之后触发
  graphStateChange: 'graphstatechange',

  // 使用了 'activate-relations' Behavior 并触发了该行为后，该事件被触发
  afterActivateRelations: 'afteractivaterelations',

  // 使用了 'brush-select' , 'click-select' 或 'lasso-select' Behavior 且选中元素发生变化时，该事件被触发
  nodeSelectChange: 'nodeselectchange',

  // 在 TreeGraph 上使用了 'collapse-expand' Behavior 并触发了该行为后，该事件被触发
  itemCollapsed: 'itemcollapsed',

  // 使用了 'tooltip' 或 'edge-tooltip' Behavior 且 tooltip 的显示/隐藏被改变后，该事件被触发
  toolTipChange: 'tooltipchange',

  // 使用了 'zoom-canvas' Behavior 并用滚轮对图进行缩放后，该事件被触发
  wheelZoom: 'wheelzoom',

  // 调用 graph.moveTo，graph.translate，或 graph.zoom 均会触发该事件
  viewportChange: 'viewportchange',

  // 使用了 'drag-node' Behavior，当拖动结束时，该事件被触发
  dragNodeEnd: 'dragnodeend',

  // 撤销/重做栈发生变化时，该事件触发
  stackChange: 'stackchange',

  

  // 时间轴的时间范围发生变化时触发
  valueChange: 'valuechange',
  
  // 时间轴开始播放时触发
  timeBarstartPlay: 'timebarstartplay',
  
  // 时间轴播放结束时触发
  timeBarendPlay: 'timebarendplay'
};




















